import { ChevronRight as ChevronRightIcon, Table2 } from 'lucide-react';
import { Badge } from '@reflex/ui/components/ui/badge';
import { Card } from '@reflex/ui/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@reflex/ui/components/ui/collapsible';
import type { PluginTableSchema } from '@/lib/plugin-registry';
import { ConstraintBadge } from './ConstraintBadge';

export function TableSchemaCard({ table }: { table: PluginTableSchema }) {
  const pk = table.columns.find((c) => /PRIMARY\s+KEY/i.test(c.constraints));
  return (
    <Collapsible>
      <Card className="p-4" data-testid={`plugin-table-card-${table.name}`}>
        <div className="space-y-3">
          <CollapsibleTrigger
            data-testid={`plugin-table-toggle-${table.name}`}
            className="group flex w-full items-center gap-2 text-left"
          >
            <Table2 className="h-4 w-4 text-muted-foreground" />
            <span className="font-mono text-sm font-medium">{table.name}</span>
            <Badge variant="outline" className="text-xs font-normal">
              {table.columns.length} col{table.columns.length !== 1 ? 's' : ''}
            </Badge>
            {pk && <span className="font-mono text-xs text-muted-foreground">pk: {pk.name}</span>}
            <ChevronRightIcon className="ml-auto h-3.5 w-3.5 text-muted-foreground transition-transform group-data-[state=open]:rotate-90" />
          </CollapsibleTrigger>

          <div className="flex flex-wrap gap-1">
            {table.columns.map((col) => (
              <Badge key={col.name} variant="secondary" className="text-xs font-normal">
                {col.name}
              </Badge>
            ))}
          </div>

          <CollapsibleContent>
            <div className="space-y-1.5 border-l-2 border-border pl-6">
              {table.columns.map((col) => (
                <div key={col.name} className="flex items-center gap-2 text-xs">
                  <span className="font-mono font-medium">{col.name}</span>
                  <Badge variant="outline" className="px-1.5 py-0 font-mono text-3xs font-normal">
                    {col.type}
                  </Badge>
                  {col.constraints && <ConstraintBadge constraint={col.constraints} />}
                </div>
              ))}
            </div>
          </CollapsibleContent>
        </div>
      </Card>
    </Collapsible>
  );
}
